function Tabs(){
    
    jQuery(function() {
        let tabs = jQuery(".gastops__tab-tabs .wp-block-button");
        let tabContent = jQuery(".gastops__tab-tab--content .wp-block-group");
        // let tabContent = 
        jQuery(tabs).click(function(e){
            e.preventDefault();
            // let previousActiveTab = jQuery(".gastops__tab-tabs .wp-block-button.active");
            // let previousTabTarget = jQuery(previousActiveTab).find(".wp-block-button__link").attr("href");
            // if(jQuery('body').hasClass(previousTabTarget)){
            //     jQuery('body').removeClass(previousTabTarget);
            // }       
            // console.log(previousTabTarget);
            // jQuery(tabs).removeClass("active");
            jQuery(".login__page").removeClass("active");

           
            // get target
            let targetTabContent = jQuery(this).find(".wp-block-button__link").attr("href");

            // jQuery(this).addClass("active");
            jQuery(`#${targetTabContent}`).addClass("active");
            // jQuery('body').toggleClass(targetTabContent);
           


        });

        jQuery('.login__page .login__page-select').on('change', function() {
            let targetLoginPage = jQuery(this).val();
            console.log(targetLoginPage);
            jQuery(".login__page").removeClass("active");
            jQuery(`#${targetLoginPage}`).addClass("active");
            jQuery(`#${targetLoginPage} .login__page-select` ).val(targetLoginPage);
        });
    });
}
export default Tabs;